import * as Yup from "yup";

export const CreateRewardItemSchema = Yup.object().shape({
	name: Yup.string().required("Name is required"),
	item_category_id: Yup.string().required("Category required").nullable(),
	code: Yup.string().required("Code is required"),
	qty: Yup.string().required("Quantity is required"),
	image: Yup.mixed().required("Image is required"),
});
